<template>
  <div>
    <div
      class="inner-banner-custom justify-content-center row align-items-center mb-3"
    >
      <div class="left-block text-center middleBox">
        <h2 class="mb-3">{{ $t("tools_Trad_Tools") }}</h2>
        <p>{{ $t("tools_Trad_Tools_Txt") }}</p>
      </div>
    </div>
    <div class="whiteBG p-3">
      <div
        id="customdiv"
        class="row justify-content-center align-items-center tradeHomeBase"
      >
        <div class="col-12 text-left">
          <div class="autoScrollable">
            <div class="row">
              <!-- <div class="col-12 col-md-6">
                                <div class="card border-0">
                                    <div class="card-body"> 
                                        <img class="" src="../../../../../static/fxView/images/AutoChartist.svg" alt="Icon">
                                        <div class="d-trade"> 
                                            <h4 class="card-title">{{$t('tools_Auto_Scanner')}}</h4>
                                            <p class="card-text">{{$t('tools_Auto_Scanner_txt')}} <a href="autoChartist" class="card-link" @click.prevent="link('AutoChartist-Scanner')">{{$t('tools_readmore')}}</a>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div> -->
              <div class="col-12 col-md-6">
                <div class="card border-0">
                  <div class="card-body">
                    <img
                      class=""
                      src="../../../../../static/fxView/images/vpsBlo.svg"
                      alt="Icon"
                    />
                    <div class="d-trade">
                      <h4 class="card-title">{{ $t("tools_VPS") }}</h4>
                      <p class="card-text">
                        {{ $t("tools_VPS_txt")
                        }}<a
                          href="#"
                          class="card-link"
                          @click.prevent="link('VPS')"
                          >{{ $t("tools_readmore") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="card border-0">
                  <div class="card-body">
                    <img
                      class=""
                      src="../../../../../static/fxView/images/ecnoCal.svg"
                      alt="Icon"
                    />
                    <div class="d-trade">
                      <h4 class="card-title">{{ $t("tools_Eco_Calendar") }}</h4>
                      <p class="card-text">
                        {{ $t("tools_Eco_Calendar_txt")
                        }}<a
                          href="economic-calendar"
                          class="card-link"
                          @click.prevent="link('Economic-Calendar')"
                          >{{ $t("tools_readmore") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="card border-0">
                  <div class="card-body">
                    <img
                      class=""
                      src="../../../../../static/fxView/images/traders_toolbox.svg"
                      alt="Icon"
                    />
                    <div class="d-trade">
                      <h4 class="card-title">{{ $t("tools_Trad_Toolbox") }}</h4>
                      <p class="card-text">
                        {{ $t("tools_Trad_Toolbox_txt")
                        }}<a
                          href="economic-calendar"
                          class="card-link"
                          @click.prevent="link('Trader-Tool-Box')"
                          >{{ $t("tools_readmore") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="card border-0">
                  <div class="card-body">
                    <img
                      class=""
                      src="../../../../../static/fxView/images/tradingcalculator.svg"
                      alt="Icon"
                    />
                    <div class="d-trade">
                      <h4 class="card-title">{{ $t("tools_Calculators") }}</h4>
                      <p class="card-text">
                        {{ $t("tools_Calculators_txt")
                        }}<a
                          href="#"
                          class="card-link"
                          @click.prevent="link('Calculators')"
                          >{{ $t("tools_readmore") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!--  <div class="col-12 col-md-6">
                                <div class="card border-0">
                                    <div class="card-body ">
                                        <img class="" src="../../../../../static/fxView/images/marktPlace.svg" alt="Icon">
                                        <div class="d-trade ">
                                            <h4 class="card-title">{{$t('tools_TradeMarket')}}</h4>
                                            <p class="card-text">{{$t('tools_TradeMarket_txt')}}<a href="#" class="card-link" @click.prevent="link('Trader-Market-Place')">{{$t('tools_readmore')}}</a>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div> -->
              <div class="col-12 col-md-6">
                <div class="card border-0">
                  <div class="card-body">
                    <img
                      class=""
                      src="../../../../../static/fxView/images/tradinghours.svg"
                      alt="Icon"
                    />
                    <div class="d-trade">
                      <h4 class="card-title">{{ $t("tools_Trad_Hours") }}</h4>
                      <p class="card-text">
                        {{ $t("tools_Trad_Hours_txt")
                        }}<a
                          href="#"
                          class="card-link"
                          @click.prevent="link('Trading-Hours')"
                          >{{ $t("tools_readmore") }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-12 col-md-6">
                                <div class="card border-0">
                                    <div class="card-body ">
                                        <img class="" src="../../../../../static/fxView/images/AutoChartist.svg" alt="Icon">
                                        <div class="d-trade ">
                                            <h4 class="card-title">{{$t('tools_Auto_Idea')}}</h4>
                                            <p class="card-text">{{$t('tools_Auto_Idea_txt')}}<a href="autoChartist" class="card-link" @click.prevent="link('Signals')">{{$t('tools_readmore')}}</a>
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tradingtool",
  data() {
    return {};
  },
  methods: {
    link(value) {
      this.$parent.changeTab(value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/trading_tool.vue